import { render, staticRenderFns } from "./PolTypeHelplist.vue?vue&type=template&id=6f577d65&"
import script from "./PolTypeHelplist.vue?vue&type=script&lang=js&"
export * from "./PolTypeHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports